'use client';

const SIZES = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'];

function openSizeGuide() {
  window.dispatchEvent(new CustomEvent('open-size-guide'));
}

interface CustomSizeSelectorProps {
  selectedSize: string;
  onSizeChange: (size: string) => void;
}

export default function CustomSizeSelector({
  selectedSize,
  onSizeChange,
}: CustomSizeSelectorProps) {
  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <span className="text-sm font-medium uppercase tracking-wider">
          Size
          {selectedSize && (
            <span className="font-normal text-[var(--color-text-secondary)] ml-2">
              {selectedSize}
            </span>
          )}
        </span>
        <button
          type="button"
          onClick={openSizeGuide}
          className="text-xs text-[var(--color-text-secondary)] underline hover:text-black transition-colors"
        >
          Size Guide
        </button>
      </div>
      <div className="relative">
        <select
          value={selectedSize}
          onChange={(e) => onSizeChange(e.target.value)}
          className="w-full appearance-none rounded-none border border-[var(--color-border)] bg-white px-4 py-3 pr-10 text-sm font-medium text-black cursor-pointer hover:border-black focus:border-black focus-visible:outline-none transition-colors"
        >
          <option value="" disabled>Select a size</option>
          {SIZES.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
        <svg
          className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-black"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={2}
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
      </div>
    </div>
  );
}
